export default {
      id: "triangle-usage",
      viewBox: "0 0 13 7",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#triangle",
      toString: function () {
        return this.url;
      }
    }